import { createMiddleware } from "@tanstack/react-start";

/**
 * Lazy variant of the generated `attachSupabaseAuth` middleware.
 *
 * The generated version does a top-level `import { supabase } from
 * '@/integrations/supabase/client'` which drags `@supabase/supabase-js`
 * (auth-js, storage-js, realtime/phoenix) into the initial client bundle
 * on every page — ~35 KiB of unused JS on public content pages that never
 * call a protected serverFn. Deferring the import until the first serverFn
 * call moves that code into a separate chunk and keeps it off the LCP path.
 */
export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    try {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data } = await supabase.auth.getSession();
      const token = data.session?.access_token;
      return next({
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
    } catch {
      return next({ headers: {} });
    }
  },
);
